// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import aboutPage from "./aboutPage";

// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();
aboutPage();

// Theme toggle is now self-initializing
import "./themeToggle";

// Turmite animation
import "./turmite";

// Clickable turmite
import "./clickableTurmite";

// Post hash generator
import "./postHash";